import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

/**
 * Load more button for feeds that page in place (the country Recents lists).
 *
 * Appearance comes from #recentsLoadMoreButton in HomePage.css, which mirrors
 * #feedViewMoreButton on the full feed page — this component sets no colours,
 * width or padding of its own. Spacing comes from the Bootstrap utilities plus
 * .recents-load-more, which adds bottom clearance for the fixed search bar and
 * nav on narrow viewports.
 *
 * @param {Object} props
 * @param {Function} props.onLoadMore - called when pressed
 * @param {boolean} props.loading - a request is in flight; disables and spins
 */
const LoadMoreButton = ({ onLoadMore, loading = false }) => {
  const { t } = useTranslation('common');
  return (
    <div className="recents-load-more d-flex justify-content-center align-items-center py-4">
      <Button
        className="clickable"
        id="recentsLoadMoreButton"
        disabled={loading}
        onClick={onLoadMore}
      >
        {loading
          ? <Spinner animation="grow" variant="light" size="sm" />
          : t('common:more', 'More')}
      </Button>
    </div>
  );
};

export default LoadMoreButton;